<template>
    <div>
      <div v-if="showMdal">
        <img style="height:18px;marign-rgith:4px;vertical-align: middle;cursor: pointer;" :src="pageDict.sourceMap[userData.row.sourceid].srcImg" alt="" :title="pageDict.sourceMap[userData.row.sourceid].srcName">
        {{pageDict.sourceMap[userData.row.sourceid].srcName}}
      </div>
      <span v-if="showMdal"></span>
    </div>
</template>

<script>
  import {mapGetters} from 'vuex'

  export default {
    name: "channel-icon",
    props:{
      sourceData:{
        type:Object
      }
    },
    data(){
      return{
        showMdal:true
      }
    },
    computed:{
      ...mapGetters(['pageDict']),

      userData(){
        if(this.sourceData.row.id){
          this.showMdal = true
        }else{
          this.showMdal = false
        }
        return this.sourceData
      }
    },

  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/render-components/render-source.vue